/**
 * Files a Task run produced (documents, slides, images), for the run panel and
 * run history on both platforms. `GET /runs/:id` gains `artifacts` in the
 * Tasks parity package; until then, and for runs that made none, this is an
 * empty list and nothing renders.
 */
import type { NovaRunDetail } from '../../lib/automation-api';
import {
  parseArtifactListResult,
  type ArtifactCardModel,
} from '../artifacts/artifact-model';

export function extractRunArtifacts(
  detail: NovaRunDetail | null | undefined,
): ArtifactCardModel[] {
  if (!detail || !Array.isArray(detail.artifacts)) return [];
  return parseArtifactListResult({ artifacts: detail.artifacts }).artifacts;
}
